export default __webpack_public_path__ + "static/designer-angela-c4a634cd2a518784d3a476ac6a7eedcb.png";